(function() {
  function initSortLinksWithFilters() {
    var links = document.querySelectorAll('.collection-toolbar__sort-link[data-sort-by]');
    if (!links.length) return;
    links.forEach(function(a) {
      var sort = a.getAttribute('data-sort-by');
      if (!sort) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort);
        u.searchParams.delete('page');
        a.setAttribute('href', u.href);
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortLinksWithFilters);
  } else {
    initSortLinksWithFilters();
  }

  var details = document.querySelectorAll('.collection-toolbar__details');
  if (!details.length) return;

  details.forEach(function(el) {
    el.addEventListener('toggle', function() {
      if (!el.open) return;
      details.forEach(function(other) {
        if (other !== el) other.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', function(e) {
    details.forEach(function(d) {
      if (!d.open) return;
      if (!d.contains(e.target)) {
        d.removeAttribute('open');
      }
    });
  });
})();
